import React from 'react';

import { Modal } from 'src/app/components/lib/modal';

import { CenteredModalContentText } from './wizard.styles';

type ExitModalProps = {
  onClose: () => void;
  onExitWithoutSaving: () => void;
  open: boolean;
  text?: React.ReactElement;
};

export function ExitModal({ onClose, onExitWithoutSaving, open, text }: ExitModalProps) {
  return (
    <Modal
      Content={
        <CenteredModalContentText>
          {text ?? 'Are you sure you want to exit? All progress will be lost.'}
        </CenteredModalContentText>
      }
      open={open}
      primaryActions={[
        { label: 'Exit without saving', variant: 'secondary', onClick: onExitWithoutSaving },
        {
          label: 'Keep editing',
          onClick: onClose,
        },
      ]}
      title='Exit'
      onClose={onClose}
    />
  );
}
